import { Instance, types } from 'mobx-state-tree';
import { StudentResult } from '@models/StudentResult';

export const StudentResultSheet = types
  .model('StudentResultSheetModel', {
    id: types.number,
    name: types.string,
    regNumber: types.string,
    attendance: types.number,
    customMarks: types.maybe(types.number),
    remarks: types.string,
    studentResults: types.optional(types.array(StudentResult), []),
  })
  .views((self) => ({
    get calculatedTotal() {
      let calculatedTotal = 0;
      let totalAllocatedMarks = 0;
      let isNYC = false;
      let isPC = false;

      self.studentResults.forEach((studentResult) => {
        if (studentResult.thirdAttemptMarks && !studentResult.isThirdAttemptNYC) {
          if (studentResult.isSecondAttemptNYC || studentResult.isFirstAttemptNYC) {
            isPC = true;
          }
        } else if (studentResult.secondAttemptMarks && !studentResult.isSecondAttemptNYC) {
          if (studentResult.isFirstAttemptNYC) {
            isPC = true;
          }
        } else if (studentResult.firstAttemptMarks >= 0 && !studentResult.isFirstAttemptNYC) {
          calculatedTotal += studentResult.firstAttemptMarks;
          totalAllocatedMarks += studentResult.allocatedMarks;
        } else if (
          studentResult.isFirstAttemptNYC ||
          studentResult.isSecondAttemptNYC ||
          studentResult.isThirdAttemptNYC
        ) {
          isNYC = true;
        }
      });

      if (isNYC) {
        return 'NYC';
      }

      if (isPC) {
        return 'PC';
      }

      if (!calculatedTotal) {
        return 0;
      }

      return Math.round((calculatedTotal / totalAllocatedMarks) * 100 * 10) / 10;
    },
  }))
  .actions((self) => ({
    updateTotalMarks(customMarks: number) {
      self.customMarks = customMarks;
    },
    updateRemarks(remarks: string) {
      self.remarks = remarks;
    },
  }));

export type StudentResultSheetModelType = Instance<typeof StudentResultSheet>;
